/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Pattern_Matched_TextInputs */



/**
* | output |
* | --- |
* | "Matched text" |
*
* @param {Audit_Details_Pattern_Matched_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_pattern_matched_text = /** @type {((inputs?: Audit_Details_Pattern_Matched_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Pattern_Matched_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Übereinstimmender Text")
	return /** @type {LocalizedString} */ ("Matched text")
});